import { render, staticRenderFns } from "./Merch.vue?vue&type=template&id=2788dff3&"
import script from "./Merch.vue?vue&type=script&lang=js&"
export * from "./Merch.vue?vue&type=script&lang=js&"
import style0 from "./Merch.vue?vue&type=style&index=0&id=2788dff3&prod&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports